var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden)?_c('div',{staticClass:"cell-marker-component"},[_c('span',{class:`cell-marker ${_vm.color}`})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }